import * as React from 'react'
import {createContext} from "use-context-selector";
import {useAppContextState} from "../../@hooks";

const Context = createContext({})

const initialState = {
    timerCompetition: null, statusCompetition: null, isCompetitionRefresh: null, finishedCompetitionRefresh: false,
    timerParity: null, statusParity: null, isParityRefresh: null, finishedParityRefresh: false,
    timerPackages: null, statusPackages: null, isPackagesRefresh: null, finishedPackagesRefresh: false,
}

export function AppRefreshDataProvider({children}) {
    const { state, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{state, updateState}}>
        {children}
    </Context.Provider>
}

export default Context